import moment from "moment-timezone";
import { DISPLAY_DATE_FORMAT2 } from "../../constants";
import { formatNumber, Unit } from "../../helpers/unit";

const fieldDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.field_geo_shape_uuid || 'unknown'] = e.field_geo_shape_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const sourceFieldDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.source_field_uuid || 'unknown'] = e.source_field_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const offloadDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.offload_geo_shape_uuid || 'unknown'] = e.offload_geo_shape_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const sourceOffloadDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.source_offload_geo_shape_uuid || 'unknown'] = e.source_offload_geo_shape_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const storageDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.offload_geo_storage_location_uuid || 'unknown'] = e.offload_geo_storage_location_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const sourceStorageDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.source_offload_geo_storage_location_uuid || 'unknown'] = e.source_offload_geo_storage_location_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const pipeDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.pipe || 'Unknown'] = e.pipe || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const targetEgDropDownList = (data, searchText) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.target_equipment_group_uuid || 'unknown'] = e.target_equipment_group_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const sourceEgDropDownList = (data, searchText) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.source_equipment_group_uuid || 'unknown'] = e.source_equipment_group_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const crewDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.crew_uuid || 'unknown'] = e.crew_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
		}
		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
	});

	return filteredIds;
};

const loadParamsDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		let loadParams = e.load_params || {};
		dropdownList[loadParams[keyName] || 'unknown'] = loadParams[keyName] || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(fieldId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: fieldId, label: fieldId });
		}
		else filteredIds.push({ id: fieldId, label: fieldId });
	});

	return filteredIds;
};

// const seedSupplierDropDOwnList = (data, searchText, keyName) => {
// 	const uniqueFields = (data || []).reduce((dropdownList, e) => {
// 		dropdownList[e.supplier || 'unknown'] = e.supplier || 'Unknown';
// 		return dropdownList;
// 	}, {});

// 	let filteredIds = [];

// 	Object.keys(uniqueFields).forEach(fieldId => {
// 		if (searchText.trim().length > 0) {
// 			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
// 				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 		}
// 		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 	});

// 	return filteredIds;
// };

// const seedLotDropDownList = (data, searchText, keyName) => {
// 	const uniqueFields = (data || []).reduce((dropdownList, e) => {
// 		dropdownList[e.seed_lot || 'unknown'] = e.seed_lot || 'Unknown';
// 		return dropdownList;
// 	}, {});

// 	let filteredIds = [];

// 	Object.keys(uniqueFields).forEach(fieldId => {
// 		if (searchText.trim().length > 0) {
// 			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
// 				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 		}
// 		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 	});

// 	return filteredIds;
// };

// const seedClassDropDownList = (data, searchText, keyName) => {
// 	const uniqueFields = (data || []).reduce((dropdownList, e) => {
// 		const seedClass = e.load_params && e.load_params.seed_class ? e.load_params.seed_class : null;
// 		dropdownList[seedClass || 'unknown'] = seedClass || 'Unknown';
// 		return dropdownList;
// 	}, {});

// 	let filteredIds = [];

// 	Object.keys(uniqueFields).forEach(fieldId => {
// 		if (searchText.trim().length > 0) {
// 			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
// 				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 		}
// 		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 	});

// 	return filteredIds;
// };

// const getDropDownList = (data, searchText, keyName) => {
// 	const uniqueFields = (data || []).reduce((dropdownList, e) => {
// 		const value = e[keyName] || 'unknown';
// 		dropdownList[value] = value;
// 		return dropdownList;
// 	}, {});

// 	let filteredIds = [];

// 	Object.keys(uniqueFields).forEach(fieldId => {
// 		if (searchText.trim().length > 0) {
// 			if (uniqueFields[fieldId].toLowerCase().includes(searchText.toLowerCase()))
// 				filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 		}
// 		else filteredIds.push({ id: fieldId, label: uniqueFields[fieldId] });
// 	});

// 	return filteredIds;
// };

const cropDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.crop_name || 'unknown'] = e.crop_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(crop_name => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[crop_name].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: crop_name, label: uniqueFields[crop_name] });
		}
		else filteredIds.push({ id: crop_name, label: uniqueFields[crop_name] });
	});

	return filteredIds;
};

const vendorDropDownList = (data, searchText, keyName) => {
	const uniqueFields = (data || []).reduce((dropdownList, e) => {
		dropdownList[e.target_equipment_vendor_id || 'unknown'] = e.target_equipment_vendor_name || 'Unknown';
		return dropdownList;
	}, {});

	let filteredIds = [];

	Object.keys(uniqueFields).forEach(vendorId => {
		if (searchText.trim().length > 0) {
			if (uniqueFields[vendorId].toLowerCase().includes(searchText.toLowerCase()))
				filteredIds.push({ id: vendorId, label: uniqueFields[vendorId] });
		}
		else filteredIds.push({ id: vendorId, label: uniqueFields[vendorId] });
	});

	return filteredIds;
};

const getFilterRange = (keyName) => {
	switch (keyName) {
		case "seconds": return [{ value: 60, label: "1m" }, { value: 600, label: "10m" }, { value: 3600, label: "1hr" }];
		case "lbs": return [{ value: 25000, label: "25000" }, { value: 50000, label: "50000" }, { value: 100000, label: "100000" }];
		case "sacks": return [{ value: 250, label: "250" }, { value: 500, label: "500" }, { value: 1000, label: "1000" }];
		case "tons":
		case "tonnes": return [{ value: 15, label: "15" }, { value: 30, label: "30" }, { value: 50, label: "50" }];
		case "approve": return [{ value: true, label: "Approved" }, { value: false, label: "Not Approved" }];
		default: return null;
	}
};

export const getFilterLabelList = (keyName, weightShortName) => {
	const range = getFilterRange(keyName);
	if (!range) return [];
	if (keyName === "approve") return [{ id: 1, label: range[0].label }, { id: 2, label: range[1].label }];
	else if (keyName === "seconds") return [
		{ id: 1, label: `Below ${range[0].label}` },
		{ id: 2, label: `${range[0].label} - ${range[1].label}` },
		{ id: 3, label: `${range[1].label} - ${range[2].label}` },
		{ id: 4, label: `${range[2].label} & Above` }
	];
	else return [
		{ id: 1, label: `Below ${range[0].label} (${(weightShortName)})` },
		{ id: 2, label: `${range[0].label} - ${range[1].label} (${(weightShortName)})` },
		{ id: 3, label: `${range[1].label} - ${range[2].label} (${(weightShortName)})` },
		{ id: 4, label: `${range[2].label} (${(weightShortName)}) & Above` }
	];
};

export const filterDropDownList = (data, searchText, keyName, weightShortName, loadQueueParams = []) => {
	if (data && data.history && data.history.length === 0) return {};
	const loadParams = loadQueueParams.map(it => it.key);
	let loadParamsOptions = {};
	if (loadParams.includes(keyName)) loadParamsOptions = { [keyName]: loadParamsDropDownList(data.history, searchText, keyName) };
	return {
		field_geo_shape_uuid: fieldDropDownList(data.history, searchText, keyName),
		source_field_uuid: sourceFieldDropDownList(data.history, searchText, keyName),
		source_offload_geo_shape_uuid: sourceOffloadDropDownList(data.history, searchText, keyName),
		source_offload_geo_storage_location_uuid: sourceStorageDropDownList(data.history, searchText, keyName),
		offload_geo_shape_uuid: offloadDropDownList(data.history, searchText, keyName),
		offload_geo_storage_location_uuid: storageDropDownList(data.history, searchText, keyName),
		crew_uuid: crewDropDownList(data.history, searchText, keyName),
		target_equipment_group_uuid: targetEgDropDownList(data.history, searchText, keyName),
		source_equipment_group_uuid: sourceEgDropDownList(data.history, searchText, keyName),
		pipe: pipeDropDownList(data.history, searchText, keyName),
		load_capacity: getFilterLabelList(weightShortName, weightShortName),
		load_seconds: getFilterLabelList('seconds', weightShortName),
		crop_name: cropDropDownList(data.history, searchText, keyName),
		target_equipment_vendor_id: vendorDropDownList(data.history, searchText, keyName),
		...loadParamsOptions
	};
};

export const checkUnknown = name => {
	if (!name) return false;
	return ((name || '').toLowerCase() === 'unknown');
};

export const filterSeedData = (data, key, filteredIds, weightShortName) => {
	let result = [];
	const seedData = data && data.history ? [...data.history] : [];

	const ids = Object.keys(filteredIds).filter(e => filteredIds[e] ? filteredIds[e].length > 0 : null);
	if (ids.length === 0) return seedData;

	seedData.forEach(item => {
		let isFiltered = true;
		const loadParams = Object.keys(item.load_params || {});
		for (const element of ids) {
			if (!loadParams.includes(element)) {
				if (element !== 'load_capacity' && element !== 'load_seconds') {
					if (!(filteredIds[element].includes('unknown'))) {
						if (item[element] && !(filteredIds[element].includes(item[element].toString()))) {
							isFiltered = false;
						}
						else if (!item[element]) {
							isFiltered = false;
						}
					} else {
						if (!(filteredIds[element].includes(item[element] ? item[element].toString() : 'unknown'))) isFiltered = false;
					}
				}
			} else {
				if (!(filteredIds[element].includes('unknown'))) {
					if (item.load_params[element] && !(filteredIds[element].includes(item.load_params[element].toString()))) {
						isFiltered = false;
					}
					else if (!item.load_params[element]) {
						isFiltered = false;
					}
				} else {
					if (!(filteredIds[element].includes(item.load_params[element] ? item.load_params[element].toString() : 'unknown'))) isFiltered = false;
				}

			}

		}

		if (isFiltered) result.push(item);
	});

	if (result.length > 0 && filteredIds['load_capacity'].length > 0) {
		result = result.filter(e => {
			let isExits = true;

			for (const item of filteredIds['load_capacity']) {
				isExits = checkLimits(weightShortName, item, e.load_capacity);
				if (isExits) break;
			}

			if (!isExits) return false;

			return isExits;
		});
	}

	result = result.filter(e => {
		let isExits = true;

		for (const item of filteredIds['load_seconds']) {
			isExits = checkLimits('seconds', item, e.load_seconds);
			if (isExits) break;
		}

		if (!isExits) return false;

		return isExits;
	});

	return result;
};

const checkLimits = (type, id, value) => {
	const unit = Unit.getInstance();
	const capacity = type === 'seconds' ? value : unit.toWeight(value);

	const range = getFilterRange(type);
	if (!range) return false;
	switch (id) {
		case 1: return capacity < range[0].value;
		case 2: return capacity >= range[0].value && capacity < range[1].value;
		case 3: return capacity >= range[1].value && capacity < range[2].value;
		case 4: return capacity >= range[2].value;
		default: return false;
	}
};

export const sortFn = (sortType, fieldType, keyName, item1, item2) => {
	const a = sortType === "asc" ? item1 : item2;
	const b = sortType === "desc" ? item1 : item2;

	//in order to sort null/zero/empty values
	if (fieldType !== "number" && (!a[keyName] || !b[keyName || a[keyName].length === 0 || b[keyName].length === 0])) {
		if (a[keyName] === null || b[keyName] === null) return item1[keyName] === null ? 1 : -1;
		if (a[keyName].length === 0 || b[keyName].length === 0) return item1[keyName].length === 0 ? 1 : -1;
		if (a[keyName] === 0 || b[keyName] === 0) return item1[keyName] === 0 ? 1 : -1;
		return 0;
	}

	if (fieldType === "text") {
		if (a[keyName].toLowerCase() < b[keyName].toLowerCase()) return -1;
		else if (a[keyName].toLowerCase() > b[keyName].toLowerCase()) return 1;
		else return 0;
	} else if (fieldType === "date") return new Date(a[keyName]) - new Date(b[keyName]);
	else if (fieldType === "number") return a[keyName] - b[keyName];
	else return 0;
};

export const getTotalCapacity = (list, isFormatToSmallScale, unit) => {
	const totalCapacity = list.reduce((capacity, item) => capacity + item.load_capacity, 0);
	return isFormatToSmallScale
		? (unit.formatNumberToSmallScale(totalCapacity, 2))
		: (formatNumber(unit.toFixedOf(totalCapacity, 2)));
};

export const getLoadDate = (list) => {
	let loadDate = list.map(e => e.load_date);
	let firstLoadDate = moment.utc(loadDate[0]).format(DISPLAY_DATE_FORMAT2);
	let lastLoadDate = moment.utc(loadDate[loadDate.length - 1]).format(DISPLAY_DATE_FORMAT2);
	return ([firstLoadDate, lastLoadDate]);
};